import { TippyV2 } from "@circle-react-shared/TippyV2";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { BookmarkTippyContent } from "./BookmarkTippyContent";
import { FolderBookmarkButton } from "./FolderBookmarkButton";
import type { Bookmark } from "./helpers/bookmark_helper";

export interface FolderDropdownProps {
  bookmark?: Bookmark;
  children?: React.ReactNode;
  onToggle?: (isOpen: boolean) => void;
}

export const FolderDropdown = ({
  bookmark,
  onToggle,
  children,
}: FolderDropdownProps) => (
  <Dropdown
    direction="bottom-start"
    size="large"
    onToggle={onToggle}
    appendTo={document.body}
    transitionWrapperClassName="pt-1.5"
    button={
      <Dropdown.MenuButton className="!py-0">
        <TippyV2
          interactive={false}
          content={<BookmarkTippyContent bookmark={bookmark} />}
          arrow
          animation="fade"
          placement="top"
          touch={false}
        >
          <FolderBookmarkButton bookmark={bookmark} />
        </TippyV2>
      </Dropdown.MenuButton>
    }
  >
    {children}
  </Dropdown>
);
